import {CustomText, H6Text, PSmallText} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {Touchable} from '@buncha/components/core/touchable';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface BarcodeInfoProps {
  itemCount: number;
  orderId: number;
  scannedBarcode: number;
  totalBarcode: number;
  onPress: () => void;
  externalOrderId: string;
}

const BarcodeInfo: React.FC<BarcodeInfoProps> = props => {
  const {
    itemCount,
    orderId,
    scannedBarcode,
    totalBarcode,
    onPress,
    externalOrderId,
  } = props;
  const muliFont = useFontTheme('muli');
  const theme = useColorThemeType();
  const {body} = useGetLocale(Modules.B2B, B2BScreens.B2BBarcode) ?? {};
  const scannedCount = `${scannedBarcode} / ${totalBarcode}`;
  return (
    <Box>
      <H6Text
        style={[
          styles.itemText,
          {
            fontFamily: muliFont[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {body?.totalItems?.replace('{itemCount}', itemCount)}
      </H6Text>
      <Touchable
        onPress={onPress}
        style={[
          styles.viewAll,
          {
            backgroundColor: theme?.background.blue[100],
            borderColor: theme?.background.blue[100],
          },
        ]}>
        <CustomText
          style={{
            fontFamily: muliFont[700].normal,
            color: theme?.text.white[100],
          }}>
          View All Items
        </CustomText>
      </Touchable>
      <CustomText
        style={[
          styles.itemText,
          {
            fontFamily: muliFont[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {body?.orderId?.replace('{orderId}', orderId)}
      </CustomText>
      <If condition={externalOrderId}>
        <CustomText
          style={[
            styles.orderText,
            {
              fontFamily: muliFont[700].normal,
              color: theme?.text.blue[300],
            },
          ]}>
          External Order ID: {externalOrderId}
        </CustomText>
      </If>
      <PSmallText
        style={{
          fontFamily: muliFont[600].normal,
          color: theme?.text.blue[300],
        }}>
        {body?.barcodesScanned}
      </PSmallText>
      <H6Text
        style={{
          fontFamily: muliFont[700].normal,
          color: theme?.text.blue[300],
        }}>
        {scannedCount}
      </H6Text>
    </Box>
  );
};

export default React.memo(BarcodeInfo);
